// Import model
import { TaxRates } from '../models/TaxRates';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { TaxLiability } from '../models/TaxLiability';

// Import dependency serializers (for complex types)
import { TaxLiabilitySerializer } from './TaxLiabilitySerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for TaxRates - handles JSON serialization and deserialization with type validation
 */
export class TaxRatesSerializer {
  /**
   * Deserializes a JSON string into a TaxRates instance
   */
  static deserialize(json: string): TaxRates {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a TaxRates instance
   */
  static fromObject(obj: any): TaxRates {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to TaxRates');
    }


    const instance: TaxRates = {
      city: obj['city'] as string | undefined,
      createDate: obj['createDate'] as string | undefined,
      destination: obj['destination'] as boolean | undefined,
      postalCode: obj['postalCode'] as string | undefined,
      state: obj['state'] as string | undefined,
      taxLiabilities: obj['taxLiabilities'] ? (obj['taxLiabilities'] as any[]).map((item: any) =>
        TaxLiabilitySerializer.fromObject(item)
      ) : [] as any,
      id: obj['_id'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of TaxRates instances
   */
  static deserializeArray(json: string): TaxRates[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a TaxRates instance to a JSON string
   */
  static serialize(instance: TaxRates): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a TaxRates instance to a plain object
   */
  static toObject(instance: TaxRates): any {
    return {
      'city': instance.city,
      'createDate': instance.createDate,
      'destination': instance.destination,
      'postalCode': instance.postalCode,
      'state': instance.state,
      'taxLiabilities': instance.taxLiabilities?.map((item: any) =>
        TaxLiabilitySerializer.toObject(item)
      ),
      '_id': instance.id,
    };
  }

  /**
   * Serializes an array of TaxRates instances to a JSON string
   */
  static serializeArray(instances: TaxRates[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
